// Count-and-drop channel attribution. The landing page sends people here with
// `?src=<meta|google|x>`. We keep that one word in this tab only, strip
// it from the address bar, and hand it to GET /profile as a header. The API
// adds one to that day's counter when (and only when) the call creates a
// brand-new profile, then forgets it. Nothing about the source is ever stored
// on the account.
const KEY = 'sp.src';
const ALLOWED = new Set(['meta', 'google', 'x']);

export function captureSource(): void {
  if (typeof window === 'undefined') return;
  try {
    const url = new URL(window.location.href);
    const raw = (url.searchParams.get('src') ?? '').toLowerCase();
    if (url.searchParams.has('src')) {
      url.searchParams.delete('src');
      const qs = url.searchParams.toString();
      window.history.replaceState(null, '', url.pathname + (qs ? `?${qs}` : '') + url.hash);
    }
    if (ALLOWED.has(raw)) window.sessionStorage.setItem(KEY, raw);
  } catch { /* never block boot */ }
}

export function getSource(): string | null {
  try {
    const v = window.sessionStorage.getItem(KEY);
    return v && ALLOWED.has(v) ? v : null;
  } catch { return null; }
}

export function clearSource(): void {
  try { window.sessionStorage.removeItem(KEY); } catch { /* ignore */ }
}
